import { Route } from './route.model';
type GroupMeta = {
  roles?: Array<string>;
  requiresBusinessType?: Array<string>;
  superRoot: boolean;
  hidden?: boolean;
  icon?: string;
  $group?: Group;
  description?: string;
};

export class Group {
  constructor(
    public name: string,
    public id: string,
    public routes: Array<Route | Group>,
    public meta: GroupMeta
  ) {
    this.injectGroup();
  }

  get path(): string {
    const validation = (route: Route) =>
      !route.meta.validator ||
      (route.meta.validator && route.meta.validator().isValid);

    const firstAvailableRoute = this.getVisibleRoutes().find(validation);

    return firstAvailableRoute ? firstAvailableRoute.path : '';
  }

  private injectGroup() {
    this.routes.forEach(route => {
      (route as Route).meta.$group = this;
    });
  }

  public getVisibleRoutes(): Route[] {
    const routes = this.routes.filter(
      route => !(route as Group).id && route.isVisible()
    );
    return routes as Route[];
  }

  public getVisibleRoutesAndGroup(): (Route | Group)[] {
    return this.routes.filter(route => {
      const hideFromMenu = (route as Route).meta.hideFromMenu;
      return (
        route.isVisible() &&
        route.meta &&
        (!hideFromMenu || typeof hideFromMenu !== 'function' || !hideFromMenu())
      );
    });
  }

  public isVisible() {
    return !this.meta.hidden && this.getVisibleRoutes().length > 0;
  }

  public hasLeftBar() {
    return this.getVisibleRoutes().length > 1;
  }
}
